import CheckCellCallback from './CheckCellCallback';

export default CheckCellCallback;
